import { Component } from 'react';
import { Badge, Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import lib1Img from '../../assets/images/lib-1.png';
import lib2Img from '../../assets/images/lib-2.png';
import lib3Img from '../../assets/images/lib-3.png';
import lib4Img from '../../assets/images/lib-4.png';
import { t } from '../../helpers/translation_helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { faBell, faCalendar, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { GET } from '../../api';
import { toast } from 'react-toastify';
import SweetAlert from 'react-bootstrap-sweetalert';
import FullCalendar from '@fullcalendar/react'; // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper';

class LibraryDashboard extends Component {

  sendNotificationConfirm = {
    show: false,
    action: () => { }
  }

  state = {
    overdueBooks: [],
    totalBooksCount: 0,
    availableBooksCount: 0,
    leasedBooksCount: 0,
    overdueBooksCount: 0,
    sendNotificationConfirm: this.sendNotificationConfirm,
    todayCenterCalendar: [],
    centerCalendar: [],
    calendarIsExpanded: false,
    fadeInAnimControl: true,
    showFullCalendar: false,
  };

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    try {
      const res = await GET('library-dashboard/get-data');

      if (res.status === 200) {
        const data = res.data;
        this.setState({
          totalBooksCount: data.total_books_count,
          availableBooksCount: data.available_books_count,
          leasedBooksCount: data.leased_books_count,
          overdueBooksCount: data.overdue_books_count,
          overdueBooks: data.overdue_books,
          todayCenterCalendar: data.today_center_calendar,
        });
      } else {
        console.error('Failed to fetch library data:', res);
      }

    } catch (err) {
      console.error('Error fetching library data:', err);
    }
  }

  getCenterCalendar = async (arg) => {
    if (arg == undefined) {
    } else {
      this.dateStart = arg.start;
      this.dateEnd = arg.end;
    }
    this.setState({
      events: null,
    });

    const request_params = {
      startdate: moment(this.dateStart).format('YYYY-MM-DD'),
      enddate: moment(this.dateEnd).format('YYYY-MM-DD'),
    };

    try {
      const res = await GET('library-dashboard/get-center-calendar', {
        params: request_params,
      });

      console.log('res.data', res.data);

      if (res.status == 200) {
        this.setState({
          centerCalendar: res.data,
        });
      }
    } catch (err) {
      console.log('err', err);

      toast.error(t('Something went wrong!'));
    }
  }

  sendNotificationReport = async (obj) => {
    try {
      let cancelToken;

      if (cancelToken) {
        cancelToken.abort();
      }

      cancelToken = new AbortController();
      const res = await GET('book-leasing/send-notification', {
        signal: cancelToken.signal,
        params: {
          parent_id: obj.parent_id,
          child_id: obj.child_id,
          class_id: obj.class_id,
        },
      });
      if (res) {
        let resData = res.data;
        if (resData.type) {
          this.setState({
            sendNotificationConfirm: {
              show: false,
              action: () => { }
            }
          });
        }
        toast.success(resData.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  render() {
    const { lang_orientation: dir } = this.props.defaultLanguage;

    const regionalStorageURL = getRegionalStorageURL(this.props.authData.centerData.tenant_id);

    const widgetStyle = {
      backgroundColor: '#fff',
      borderRadius: 7,
      padding: '10px 15px',
      height: 210,
      width: '25%',
      marginRight: 14,
      backgroundPosition: 'bottom right',
      backgroundRepeat: 'no-repeat',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      backgroundSize: '60%',
    }

    return (
      <div className='grey-section mb-0' style={{ marginLeft: 12, borderRadius: 14, padding: 14, height: 'calc(100vh - 135px)', overflowY: 'auto', overflowX: 'hidden', display: 'flex', justifyContent: 'end' }}>
        <div style={{
          opacity: this.state.calendarIsExpanded ? 0.5 : 1,
          transition: 'opacity 0.3s ease',
          minWidth: '75%',
          display: 'inline-block'
        }}>
          <div style={{ display: 'flex', marginBottom: 14, }}>
            <div style={{
              ...widgetStyle,
              backgroundImage: `url(${lib1Img})`,
            }}>
              <strong>{t('Total Books')}</strong>
              <div style={{ fontSize: 80, color: '#934DFF', lineHeight: '80px' }}>
                {this.state.totalBooksCount}
              </div>
            </div>
            <div style={{
              ...widgetStyle,
              backgroundImage: `url(${lib2Img})`,
            }}>
              <strong>{t('Available Books')}</strong>
              <div style={{ fontSize: 80, color: '#DD4488', lineHeight: '80px' }}>
                {this.state.availableBooksCount}
              </div>
            </div>
            <div style={{
              ...widgetStyle,
              backgroundImage: `url(${lib3Img})`,
            }}>
              <strong>{t('Leased Books')}</strong>
              <div style={{ fontSize: 80, color: '#83868D', lineHeight: '80px' }}>
                {this.state.leasedBooksCount}
              </div>
            </div>
            <div style={{
              ...widgetStyle,
              backgroundImage: `url(${lib4Img})`,
            }}>
              <strong>{t('Overdue Books')}</strong>
              <div style={{ fontSize: 80, color: '#A80000', lineHeight: '80px' }}>
                {this.state.overdueBooksCount}
              </div>
            </div>
          </div>
          <div
            style={{
              background: '#fff',
              borderRadius: 7,
              alignItems: 'center',
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
              position: 'relative',
              marginRight: 14,
              marginBottom: 14,
              minHeight: 'calc(100vh - 387px)',
            }}>
            <div className='p-2'>
              <Row>
                <Col className='d-flex align-items-center ps-3'><strong>{t('Overdue Books')}</strong></Col>
              </Row>
            </div>
            <div style={{ borderTop: '#f2f2f2 1px solid', height: 'calc(100vh - 430px)', overflowY: 'auto' }}>
              {this.state.overdueBooks.length === 0 &&
                <div className='d-flex justify-content-center align-items-center p-3' style={{ color: '#ccc', minHeight: '100%' }}>{t('No overdue books found!')}</div>
              }
              {this.state.overdueBooks.length > 0 && this.state.overdueBooks.map((book, index) => (
                <div key={index} className='p-3' style={{
                  borderBottom: '#f2f2f2 1px solid',
                }}>
                  <Row>
                    <Col md={3} className='d-flex align-items-center ps-2 pe-0'>
                      <div style={{
                        width: 35,
                        height: 35,
                        borderRadius: (35 / 2),
                        background: '#F2F2F2',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginRight: 10,
                        overflow: 'hidden',
                      }}>
                        {book.picture ?
                          <img src={regionalStorageURL +
                            this.props.authData.centerData.center_uuid +
                            '/children/' + book.picture} alt={book.child_name} style={{ width: 35, height: 35 }} />
                          :
                          <img src={require('../../assets/images/broken-img.png')} alt={book.child_name} style={{ width: 20, height: 20 }} />
                        }
                      </div>
                      <span className='fw-bold' style={{ fontSize: 14 }}>{book.child_name}</span>
                    </Col>
                    <Col md={'auto'} className='ps-2 pe-0'>
                      <div style={{ width: 30, height: 42, borderRadius: 7, overflow: 'hidden', background: '#F2F2F2' }}
                        className='d-flex justify-content-center align-items-center'>
                        {book.book_pic ?
                          <img src={regionalStorageURL + this.props.authData.centerData.center_uuid +
                            '/books/' +
                            book.book_pic} style={{ width: 30, height: 42 }} alt='' /> :
                          <img src={require('../../assets/images/broken-img.png')} alt={'N/A'} style={{ width: 20, height: 20 }} />
                        }
                      </div>
                    </Col>
                    <Col md={5} className='ps-2 d-flex flex-column'>
                      <strong style={{ fontSize: 14, lineHeight: '19px' }}>{book.book_title}</strong>
                      <small className='text-muted' style={{ fontSize: 12 }}>{book.book_author}</small>
                    </Col>
                    <Col className='position-relative'>
                      <span
                        style={{
                          display: 'inline-block',
                          background: book.book_lease_due_date && moment(book.book_lease_due_date).isBefore(moment(), 'day') ? '#F5D7DA' : '#E7E8E9',
                          borderRadius: 7,
                          color: '#0C121F',
                          border: 0,
                          fontSize: 12,
                          padding: '4px 8px',
                          position: 'relative',
                          zIndex: 1,
                          width: 95
                        }}>
                        <FontAwesomeIcon className='me-1' icon={faCalendar} />
                        {moment(book.book_lease_due_date).format('DD-MM-YYYY')}
                      </span>
                      <br />
                      {book.book_lease_due_date && moment(book.book_lease_due_date).isBefore(moment(), 'day') && (
                        <Badge bg="danger" style={{
                          fontSize: 9,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                          top: 15,
                          position: 'absolute',
                          width: 95,
                          padding: '14px 0 0.2rem 0',
                          textTransform: 'uppercase',
                        }}>
                          {moment().diff(moment(book.book_lease_due_date), 'days')} {
                            moment().diff(moment(book.book_lease_due_date), 'days') == 1 ? t('day overdue') :
                              t('days overdue')
                          }
                        </Badge>
                      )}
                    </Col>
                    <Col className='d-flex justify-content-end align-items-center'>
                      <Button variant='warning'
                        onClick={() => this.setState({
                          sendNotificationConfirm: {
                            show: true,
                            action: () => this.sendNotificationReport(book)
                          }
                        })}
                        style={{
                          borderRadius: 20,
                          width: 35,
                          height: 35,
                          padding: 0,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}>
                        <FontAwesomeIcon icon={faBell} style={{ color: '#fff', fontSize: 18 }} />
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div style={{
          minWidth: this.state.calendarIsExpanded ? '95%' : '25%',
          display: 'inline-block',
          background: '#fff',
          borderRadius: 7,
          transitionDuration: '300ms',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        }}>
          <div style={{ padding: 15, display: 'flex', alignItems: 'center', borderBottom: '#f2f2f2 1px solid' }}>
            <button
              onClick={() => {
                this.setState({
                  fadeInAnimControl: !this.state.fadeInAnimControl,
                  calendarIsExpanded: !this.state.calendarIsExpanded
                }, () => {
                  setTimeout(() => {
                    this.setState({ showFullCalendar: !this.state.showFullCalendar }, () => {
                      setTimeout(() => {
                        this.setState({ fadeInAnimControl: !this.state.fadeInAnimControl });
                      }, 10);
                    });
                  }, 300);
                })
              }}
              style={{
                width: 35,
                height: 35,
                borderRadius: 35 / 2,
                padding: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '#5BBD4A 1px solid',
                background: '#fff',
                marginRight: 10,
              }}>
              <FontAwesomeIcon style={{
                transform: this.state.calendarIsExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
              }}
                icon={faChevronLeft} color='#5BBD4A' />
            </button>
            <h5 className='m-0'>{t('Due Books')}<small className='text-muted'>{!this.state.calendarIsExpanded && `, ` + moment().format('DD-MM-YYYY')}</small></h5>
          </div>
          <div
            style={{
              height: 'calc(100vh - 229px)',
              overflowY: 'auto',
              padding: 15,
              boxSizing: 'border-box',
              opacity: this.state.fadeInAnimControl ? 1 : 0,
              transition: 'opacity 300ms',
            }}>
            {!this.state.showFullCalendar ? (
              <>
                {this.state.todayCenterCalendar.length === 0 &&
                  <div className='d-flex justify-content-center align-items-center' style={{ color: '#ccc', height: '100%' }}>
                    {t('No due books today!')}
                  </div>
                }
                {this.state.todayCenterCalendar.length > 0 && this.state.todayCenterCalendar.map((item, index) => (
                  <div style={{
                    background: '#538DEE',
                    padding: '5px 10px',
                    borderRadius: 7,
                    fontSize: 13,
                    color: '#fff',
                    marginBottom: 10,
                  }}>
                    {item.title}
                  </div>
                ))}
              </>
            ) : (
              <div
                style={{
                  opacity: this.state.fadeInAnimControl ? 1 : 0,
                  transition: 'opacity 300ms',
                }}
              >
                <div style={{ height: 600 }}>
                  <FullCalendar
                    headerToolbar={{
                      left: "today prev,next",
                      center: "title",
                      right: "dayGridMonth,timeGridWeek,listWeek",
                    }}
                    plugins={[
                      dayGridPlugin,
                      interactionPlugin,
                      timeGridPlugin,
                      listPlugin,
                    ]}
                    initialView='dayGridMonth'
                    datesSet={this.getCenterCalendar}
                    events={this.state.centerCalendar}
                    height={'100%'}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        {/* Send Notification Confirmation */}
        <SweetAlert SweetAlert show={this.state.sendNotificationConfirm.show} warning showCancel confirmBtnText={t('Yes, send it!')} confirmBtnBsStyle='info' title={t('Are you sure?')} onConfirm={this.state.sendNotificationConfirm.action} onCancel={() => this.setState({ sendNotificationConfirm: { show: false, action: () => { } } })
        } focusCancelBtn>
          {t('Confirm to send book return overdue notification!')}
        </SweetAlert>
      </div >
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme,
});

export default connect(mapStateToProps, null)(LibraryDashboard);
